(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesController', TabObjectTypesController);

    TabObjectTypesController.$inject = ['$scope', '$state', 'TabObjectTypes', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabObjectTypesController ($scope, $state, TabObjectTypes, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabObjectTypes = [];
        vm.applyFilter = applyFilter;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.currentState = "tab-object-types";
        vm.currentStateFilter = "tab-object-types-filter";
        vm.device = pagingParams.device;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        var filter = localStorage.getItem(vm.currentStateFilter);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.device = filter.device;
            }
        }

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            };
            addFilter(body);
            TabObjectTypes.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabObjectTypes = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i=0; i < data.length; ++i) {
                    vm.tabObjectTypes.push(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(device) {
            var filter = {};
            filter.device = vm.device = device;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.tabObjectTypes = [];
            vm.page = pagingParams.page;
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.device.id !== -1)
                body.deviceId = vm.device.id;
        }

        vm.reset = function() {
            vm.page = 0;
            vm.tabObjectTypes = [];
            var orderCall = vm.loadAll();
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();


    }
})();
